<template>
  <section>
    <qx-search-box
      class="searchBox"
      ref="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList, getDepartmentAllList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        stateOptions: [],
        statusOptions: [],
        // 归属部门
        orgIdOptions: [],
        form: [
          {
            label: '',
            value: 'status',
            type: 'radio',
            default: -1,
            class: 'especial-radio-group',
            onChangeRadio: () => {
              this.$refs.searchBox.sub();
            },
          },
          { // 客户编码
            label: '客户编码',
            value: 'customerCode',
            type: 'input',
            placeholder: '请输入客户编码',
          },
          { // 客户全称
            label: '客户全称',
            value: 'companyName',
            type: 'input',
            placeholder: '请输入客户全称',
          },
          { // 客户状态
            label: '客户状态',
            value: 'state',
            type: 'select',
            default: -1,
            placeholder: '请选择客户状态',
          },
          {
            label: '归属部门',
            value: 'orgId',
            type: 'select',
            default: -1,
            placeholder: '请输入归属部门',
          },
          // { // 认证状态
          //   label: '认证状态',
          //   value: 'status',
          //   type: 'select',
          //   default: -1,
          //   placeholder: '请选择认证状态',
          // },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      this.$refs.tableBox.saveSearchBoxData({
        state: -1,
        // status: -1,
        customerCode: '',
        companyName: '',
        customerName: '',
        ...searchBoxData,
      });
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'SYS_STATE_DESC,CM_CUSTOMER_INFO.AUTHSTATE',
    });
    this.searchBoxData.stateOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[0],
    ];
    this.searchBoxData.statusOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[1],
    ];
    this.searchBoxData.orgIdOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...await getDepartmentAllList({
        isArchive: true,
      }),
    ];
  },
};
</script>

<style lang="scss" scoped>
</style>
